const types = {
  SET_COMPANY: 'SET_COMPANY',
  SET_BRAND_ACTIONS: 'SET_BRAND_ACTIONS',
  SET_WORD_CLOUD: 'SET_WORD_CLOUD',
  SET_METRIC: 'SET_METRIC',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/companies/mutations-types.js